import Vue from 'vue'
import VueRouter from 'vue-router'

// pages
import Home from '../views/Home.vue'
import NotFound from '../views/NotFound.vue'
import LandingPage from '../views/LandingPage.vue'
import Items from '../views/Items.vue'
import Item from '../views/Item.vue'

import Consultations from '../views/Consultations.vue'
import Consultation from '../views/Consultation.vue'
import NewConsultation from '../views/ConsultationAdd.vue'

import Articles from '../views/Articles.vue'
import Article from '../views/Article.vue'

import Clubs from '../views/Clubs.vue'

import Trainings from '../views/Trainings.vue'

import CheckYourSelf from '../views/CheckYourSelf.vue'

import ContactUs from '../views/ContactUs.vue'

import AbouCEO from '../views/AbouCEO.vue'
import AboutUs from '../views/AboutUs.vue'

import Experts from '../views/Experts.vue'
import DoctorProfile from '../views/DoctorProfile.vue'

import Media from '../views/Media.vue'
import Creative from '../views/Creative.vue'
import Books from '../views/Books.vue'

import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'

import routeAuth from "../utils/RoutingHelper.js"
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    // beforeEnter: routeAuth.isLoggedIn,
  },
  {
    path: '/items',
    name: 'items',
    component: Items
  },
  {
    path: '/item',
    name: 'item',
    component: Item
  },

  // consultations
  {
    path: '/consultations',
    name: 'consultations',
    component: Consultations
  },
  {
    path: '/consultation/:id',
    name: 'consultation',
    component: Consultation
  },
  {
    path: '/new-consultation',
    name: 'newConsultation',
    component: NewConsultation
  },

  // Articles
  {
    path: '/articles',
    name: 'articles',
    component: Articles
  },
  {
    path: '/article/:id',
    name: 'article',
    component: Article
  },

  // Clubs
  {
    path: '/clubs',
    name: 'clubs',
    component: Clubs
  },

  // Trainings
  {
    path: '/trainings',
    name: 'trainings',
    component: Trainings
  },

  // checkYourSelf
  {
    path: '/checkYourSelf',
    name: 'checkYourSelf',
    component: CheckYourSelf
  },

  // contactUs
  {
    path: '/contactUs',
    name: 'contactus',
    component: ContactUs
  },

  // aboutus
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: AboutUs
  },

  // Experts
  {
    path: '/experts/:id',
    name: 'expertProfile',
    component: DoctorProfile,
  },
  {
    path: '/experts',
    name: 'experts',
    component: Experts
  },
  
  // Media
  {
    path: '/media',
    name: 'media',
    component: Media
  },

  // Creative
  {
    path: '/creative',
    name: 'creative',
    component: Creative
  },

  // Books
  {
    path: '/books',
    name: 'books',
    component: Books
  },
   
  // About CEO
  {
    path: '/abouCEO',
    name: 'abouCEO',
    component: AbouCEO
  },

  // PrivacyPolicy
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: PrivacyPolicy
  },

    // TermsAndConditions
  {
    path: '/termsAndConditions',
    name: 'termsAndConditions',
    component: TermsAndConditions
  },

  // LandingPage
  {
    path: '/',
    name: 'landingPage',
    component: LandingPage
  },

  //NotFound
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    // beforeEnter: routeAuth.isLoggedIn,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes, 
  scrollBehavior(to, from, savedPosition) {
    // Scroll to top for all routes
    if (savedPosition) {
      return savedPosition; // For back/forward navigation
    } else {
      return { x: 0, y: 0 }; // Scroll to top
    }
  },
})

export default router